<template>
  <div class="">
    <div>
      <PaymentHeaderTop></PaymentHeaderTop>
      <router-view class="w-100"/>
      <PaymentFooter></PaymentFooter>
    </div>

  </div>
</template>

<script>

export default {
  name: 'LayoutPayment',
  components: {
    PaymentHeaderTop: () => import('@/components/PaymentHeaderTop.vue'),
    PaymentFooter: () => import('@/components/PaymentFooter.vue'),
  },
}

</script>